import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from './mobileMenu'

import gsap from 'gsap'
import { useGSAP } from '@gsap/react'
// import { MdOutlineSegment } from 'react-icons/md'

const NAV_LINKS = [
  {
    name: 'Home',
    linkPath: '',
  },
  {
    name: 'About',
    linkPath: '',
  },
  {
    name: 'Contact',
    linkPath: '',
  },
  {
    name: 'Portfolio',
    linkPath: '',
  },
]

export default function Navbar() {
  const [menuShow, setMenuShow] = useState(false)

  const HandleClick = () => {
    setMenuShow(true)
  }

  useGSAP(() => {
    var tl = gsap.timeline()

    tl.from('nav img, nav a, nav .button-1', {
      y: 100,
      duration: 0.5,
      delay: 0.3,
      opacity: 0,
      stagger: 0.2,
    })
  }, [])

  return (
    <div className='absolute w-full'>
      <nav className='md:px-10 px-5 md:py-6 py-3 flex items-center justify-between '>
        <div>
          <Link to='/'>
            <img
              src='/images/logo.png'
              alt='logo'
              className='lg:w-[100px] lg:h-[100px] md:w-16 md:h-16 w-10 h-10'
            />
          </Link>
        </div>

        <div className='flex items-center gap-3  '>
          <Link
            hrefLang=''
            className='block '
          >
            <img
              src='/images/twitter.png'
              alt='twitter'
              width={38}
              height={38}
            />
          </Link>
          <Link
            hrefLang=''
            className='block '
          >
            <img
              src='/images/telegram.png'
              alt='telegram'
              width={38}
              height={38}
            />
          </Link>
          <button className='button1 px-5 py-3 rounded-full font-semibold text-lg md:block hidden '>
            Get Started
          </button>
          <Link
            hrefLang=''
            className='bg-white button-3 hover:bg-black hover:text-white transetion-all text-black font-semibold px-5 py-3 rounded-full text-lg md:block hidden '
          >
            Buy Now
          </Link>
        </div>
        {/* <div className='md:hidden block relative'>
          <button onClick={HandleClick}>hellow</button>
        </div> */}
      </nav>
      {/* <div className='animation'>
        {menuShow && <MobileMenu setMenuShow={setMenuShow} />}
      </div> */}
    </div>
  )
}
